module.exports = __webpack_public_path__ + "5-o1.jpg?de850750d8de5d20acde85d1a8f72359";


//////////////////
// WEBPACK FOOTER
// ./src/assets/quiz/questions/5-o1.jpg
// module id = 656
// module chunks = 0